import { createFileRoute } from "@tanstack/react-router";
import { PushNotificationsManager } from "@/components/admin/PushNotificationsManager";
import { z } from "zod";

export const Route = createFileRoute("/admin/marketing/notificacoes")({
  validateSearch: z.object({ criar: z.literal("campanha").optional() }),
  component: PushNotificationsManager,
});
